import { isValidScript } from './isValidScript'

interface BundleBytes {
  scriptCount: number
  transferBytes: number
  encodedBytes: number
}

interface ComputeBundleByteArgs {
  maxStartTime?: number
  onlySameOrigin?: boolean
  pathPrefixes?: string[]
}

export const computeBundleBytes = ({
  maxStartTime = Number.POSITIVE_INFINITY,
  onlySameOrigin = true,
  pathPrefixes = ['/releases/', '/assets/', '/static/'],
}: ComputeBundleByteArgs): BundleBytes => {
  const origin = window.location.origin

  const performanceResources = (performance.getEntriesByType('resource') as PerformanceResourceTiming[]).filter(
    (resource) => isValidScript({ resource, origin, maxStartTime, onlySameOrigin, pathPrefixes }),
  )

  const totals = performanceResources.reduce(
    (acc, resource) => ({
      count: acc.count + 1,
      transfer: acc.transfer + (resource.transferSize || 0),
      encoded: acc.encoded + (resource.encodedBodySize || 0),
    }),
    { count: 0, transfer: 0, encoded: 0 },
  )

  const { count: scriptCount, transfer, encoded } = totals

  return { scriptCount, transferBytes: transfer, encodedBytes: encoded }
}
